interface AcessIconProps {
  width?: number | string;
  height?: number | string;
  color?: string;
  className?: string;
}

const AcessIcon: React.FC<AcessIconProps> = ({ width = 35, height = 24, color = '#91B1BE', className = '' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    className={className}
    viewBox='0 0 36 36'
    fill='none'
  >
    <g className='dark:child:stroke-primary-500' clipPath='url(#clip0_4_328)'>
      <path
        d='M18.834 14.451C18.8337 12.7844 18.366 11.1513 17.484 9.73714C16.6021 8.32301 15.3412 7.18456 13.8447 6.4511C12.3481 5.71764 10.6759 5.41857 9.01789 5.58786C7.35989 5.75714 5.7826 6.38801 4.46517 7.40878C3.14774 8.42956 2.14298 9.79934 1.56502 11.3625C0.987051 12.9257 0.859049 14.6197 1.19555 16.252C1.53205 17.8842 2.31956 19.3895 3.46864 20.5966C4.61772 21.8038 6.0823 22.6645 7.69603 23.081V32.194C7.70837 32.7766 7.94848 33.3312 8.36487 33.7388C8.78126 34.1465 9.3408 34.3748 9.92353 34.3748C10.5063 34.3748 11.0658 34.1465 11.4822 33.7388C11.8986 33.3312 12.1387 32.7766 12.151 32.194V23.081C14.0641 22.587 15.7587 21.4712 16.9685 19.909C18.1782 18.3468 18.8345 16.4268 18.834 14.451Z'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M20.042 23.277C21.2073 23.1169 22.329 22.7267 23.342 22.129L30.622 29.415C30.827 29.6299 31.0729 29.8016 31.3453 29.92C31.6176 30.0385 31.9109 30.1013 32.2079 30.1048C32.5048 30.1083 32.7995 30.0524 33.0745 29.9403C33.3496 29.8283 33.5994 29.6624 33.8094 29.4524C34.0194 29.2424 34.1853 28.9925 34.2974 28.7175C34.4094 28.4425 34.4653 28.1478 34.4618 27.8508C34.4584 27.5539 34.3955 27.2606 34.2771 26.9882C34.1586 26.7159 33.9869 26.47 33.772 26.265L26.48 18.979C27.4794 17.2847 27.89 15.3074 27.648 13.3553C27.4059 11.4032 26.5247 9.58601 25.1418 8.18712C23.7589 6.78824 21.952 5.88624 20.0028 5.62176C18.0536 5.35728 16.0717 5.74519 14.366 6.725'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.69604 13.342C7.69604 13.7827 7.82671 14.2134 8.07153 14.5798C8.31635 14.9462 8.66431 15.2318 9.07143 15.4004C9.47854 15.569 9.92652 15.6132 10.3587 15.5272C10.7909 15.4412 11.1879 15.229 11.4995 14.9174C11.8111 14.6058 12.0233 14.2088 12.1092 13.7767C12.1952 13.3445 12.1511 12.8965 11.9824 12.4894C11.8138 12.0823 11.5282 11.7343 11.1619 11.4895C10.7955 11.2447 10.3647 11.114 9.92404 11.114C9.33314 11.114 8.76644 11.3487 8.34861 11.7666C7.93078 12.1844 7.69604 12.7511 7.69604 13.342Z'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.92402 11.109V4.341C9.91635 3.89732 9.99711 3.45656 10.1616 3.04443C10.3261 2.6323 10.571 2.25704 10.882 1.94057C11.1931 1.62409 11.564 1.37273 11.9733 1.20115C12.3825 1.02956 12.8218 0.941193 13.2655 0.941193C13.7093 0.941193 14.1486 1.02956 14.5578 1.20115C14.967 1.37273 15.338 1.62409 15.649 1.94057C15.9601 2.25704 16.205 2.6323 16.3695 3.04443C16.5339 3.45656 16.6147 3.89732 16.607 4.341V5.81'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_4_328'>
        <rect width='35.427' height='35.421' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export default AcessIcon;
